<div class="d-flex align-items-center flex-wrap">
  <input class="form-control w-5" type="number" [required]="required" [(ngModel)]="tmpModel"
    (ngModelChange)="parseOut()" (change)="onChange()" [disabled]="disabled" min="0">

    <div ngbDropdown class="ms-1 no-print">
      <button class="btn btn-outline-secondary" type="button" ngbDropdownToggle>
        {{('date_type.'+selectedType)|translate}}
      </button>
      <div ngbDropdownMenu>
        @for (btn of intervalTypes; track btn) {
          <div ngbDropdownItem class="cursor" (click)="typeChanged(btn)">
          {{('date_type.'+btn)|translate}}</div>
        }
      </div>
    </div>
  </div>
